import type { Lang } from '../types';

export interface LoginText {
  title: string;
  subtitle: string;
  emailLabel: string;
  emailPlaceholder: string;
  passwordLabel: string;
  passwordPlaceholder: string;
  submitBtn: string;
  submittingBtn: string;
  forgotLink: string;
  noAccount: string;
  registerLink: string;
  privacyLink: string;
}

export const loginText: Record<Lang, LoginText> = {
  cs: {
    title: 'Vítejte zpět',
    subtitle: 'Přihlaste se do svého účtu správce',
    emailLabel: 'E-mailová adresa',
    emailPlaceholder: 'vy@priklad.cz',
    passwordLabel: 'Heslo',
    passwordPlaceholder: '••••••••',
    submitBtn: 'Přihlásit se',
    submittingBtn: 'Přihlašuji…',
    forgotLink: 'Zapomenuté heslo?',
    noAccount: 'Nemáte účet?',
    registerLink: 'Zaregistrujte se',
    privacyLink: 'Nastavení soukromí',
  },
  en: {
    title: 'Welcome back',
    subtitle: 'Sign in to your manager account',
    emailLabel: 'Email address',
    emailPlaceholder: 'you@example.com',
    passwordLabel: 'Password',
    passwordPlaceholder: '••••••••',
    submitBtn: 'Sign in',
    submittingBtn: 'Signing in…',
    forgotLink: 'Forgot your password?',
    noAccount: "Don't have an account?",
    registerLink: 'Create one',
    privacyLink: 'Privacy settings',
  },
  vi: {
    title: 'Chào mừng trở lại',
    subtitle: 'Đăng nhập vào tài khoản quản lý của bạn',
    emailLabel: 'Địa chỉ email',
    emailPlaceholder: 'ban@example.com',
    passwordLabel: 'Mật khẩu',
    passwordPlaceholder: '••••••••',
    submitBtn: 'Đăng nhập',
    submittingBtn: 'Đang đăng nhập…',
    forgotLink: 'Quên mật khẩu?',
    noAccount: 'Chưa có tài khoản?',
    registerLink: 'Tạo tài khoản',
    privacyLink: 'Cài đặt quyền riêng tư',
  },
  uk: {
    title: 'З поверненням',
    subtitle: 'Увійдіть до свого облікового запису',
    emailLabel: 'Електронна адреса',
    emailPlaceholder: 'ви@example.com',
    passwordLabel: 'Пароль',
    passwordPlaceholder: '••••••••',
    submitBtn: 'Увійти',
    submittingBtn: 'Вхід…',
    forgotLink: 'Забули пароль?',
    noAccount: 'Немає облікового запису?',
    registerLink: 'Створити',
    privacyLink: 'Налаштування конфіденційності',
  },
};
